import React from 'react';

export default ({product, components = []}) => (
	<React.Fragment>
		{components.map((component, index) => {
			switch (component._type) {
				// case 'homeHero':
				// 	return (
				// 		<HomeHero
				// 			index={index}
				// 			key={component._key}
				// 			{...component}
				// 		/>
				// 	);
				default:
					return null;
			}
		})}
	</React.Fragment>
);
